<template>
  <!-- 下载权益弹框 -->
  <div class="DownloadInterestModal animate__animated"
       :class="{ 'ON': DownloadInterestModal.isShow,
       'animate__fadeOutDown': !DownloadInterestModal.isShow }"
  >
    <div slot="ModalContent" class="ModalContent">
      <div
        class="Modal-close"
        @click="close">
        <i class="iconfont icon-cha"/>
      </div>

      <div class="title">您无当前素材商用授权，升级会员享全站海量下载。</div>

      <div class="flex-container">
        <div v-for="(i,idx) in database" :key="idx"
             class="flex-column"
             :class="{ 'ON' :i.layer == maxGradeVip}"
        >
          <div v-for="(j,jdx) in i.label" :key="jdx" class="flex-item">
            <i v-if="j.label === 1" class="iconfont2 icon-qy-success-circle-fill"></i>
            <i v-else-if="j.label === 0" class="iconfont2 icon-qy-error-circle-fill"></i>
            <span v-else>{{ j.label }}</span>
          </div>

          <span class="tag-curr-vip" v-if="i.layer == maxGradeVip">当前</span>

        </div>
      </div>
      <a class="upgrade-btn"
         :href="DownloadInterestModal.upgradeLink"
         target="_blank"
         @click.prevent.stop="toPay"
      >升级授权
        <span v-if="DownloadInterestModal.isOpenTimer">{{ timeCount }}s</span>
      </a>
    </div>
  </div>
</template>

<script>

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';
import _ from 'lodash'

let {COMPANY, BUSINESS, PERSON, DEFAULT} = CON_COMMON.CON_PAY.VIP_GRADE


/* 引入组件 */

/* 引入VUEX */
import {mapState} from "vuex";

/* 引入API */

export default {
  name: "DownloadInterestModal",

  components: {},
  computed: {
    ...mapState('pic', ['DownloadInterestModal', 'DownloadInterestModalTimer']),
    isOpenTimer() {
      return this.DownloadInterestModal.isOpenTimer;
    },
    isShow() {
      return this.DownloadInterestModal.isShow;
    },
    upgradeLink() {
      return this.DownloadInterestModal.upgradeLink;
    }
  },
  watch: {
    isShow: {
      handler: _.debounce(function (n, o) {
        if (n == true) {
          this.timeCount = 3;
        }
      }, 0),
    },
    isOpenTimer: {
      handler: _.debounce(function (n, o) {
        if (n == true) {
          this.openTimer();
        }
      }, 1000),
    }
  },


  mounted() {
    this.getUserMaxGradeVip();
  },
  data() {
    return {
      database: [
        {
          label: [
            {label: '下载范围'},
            {label: '免费下载'},
            {label: '个人会员'},
            // {label: '个人商用'},
            {label: '企业商用'},
          ],
          layer: ''
        },
        {
          label: [
            {label: '非会员'},
            {label: 1},
            {label: 0},
            {label: 0},
          ],
          layer: DEFAULT
        },
        {
          label: [
            {label: '个人VIP'},
            {label: 1},
            {label: 1},
            {label: 0},
          ],
          layer: PERSON
        },
        {
          label: [
            {label: '企业VIP'},
            {label: 1},
            {label: 1},
            {label: 1},
          ],
          layer: COMPANY
        },
      ],  // 表格数据
      maxGradeVip: '',  // 当前会员最高等级
      timer: null,    // 定时器
      timeCount: 3,   // 倒计时长
      flag: true,

      isShowTimer: false
    }
  },

  methods: {

    getUserMaxGradeVip() {
      this.maxGradeVip = fnCommon.fnUser.getUserMaxGradeVip();
    },
    close() {
      clearInterval(this.timer);
      fnCommon.fnPic.showDownloadInterestModal(false);
    },

    toPay() {
      fnCommon.fnPay.dataTrackByPay('充值:详情页升级弹窗:图片:click')
      let openUrl = this.DownloadInterestModal.upgradeLink;
      fnCommon.fnBasic.navigationTo(openUrl);
      this.close();
    },


    openTimer() {
      this.timeCount = 3;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timeCount -= 1;
        if (this.timeCount <= 0) {
          clearInterval(this.timer);
          this.timeCount = ''
          this.toPay();
        }
      }, 1000)
    }
  }

}
</script>

<style lang="scss" scoped>

.DownloadInterestModal {
  @include Position(1, 5, 0, 0);
  z-index: 50;
  left: 9999px;
  pointer-events: none;
  animation: fadeInLeft; /* animate__backInRight referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */


  &.ON {
    left: -477px;
    display: inline-block;
    animation: fadeInRight; /* animate__backInRight referring directly to the animation's @keyframe declaration */
    animation-duration: 1s; /* don't forget to set a duration! */
  }

  .fadeOutDown {
    animation-duration: 1s;
    animation-name: fadeOutDown;
  }
}

.ModalContent {
  width: 580px;
  //height: 339px;
  background: #FFFFFF;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 0;

  width: 457px;
  height: 273px;
  background: #FFFFFF;
  box-shadow: 0px 0px 12px 0px rgba(66,72,102,0.08);
  border-radius: 14px;
  box-sizing: border-box;


  .Modal-close {
    font-size: 18px;
    width: 40px;
    height: 40px;
    background: #ECEFF6;
    color: #596080;
    border-radius: 0 14px 0 14px;
    @include Position(1, 2, 0, 0);
    @include LayoutFlex(1);
    @include ElementHover('', #E1E3E7);


    .icon-cha {
      transition: transform 0.5s ease-out;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      display: inline-block;
      pointer-events: auto;


      &:hover {
        transform: rotateZ(180deg);
      }
    }
  }


  &:before {
    content: '';
    display: inline-block;
    width: 100%;
    height: 134px;
    background: linear-gradient(180deg, rgba(105, 105, 255, 0.12) 0%, rgba(105, 105, 255, 0) 100%);
    border-radius: 14px;
    @include Position(1, 5, 0, 0);
  }

  .title {
    height: 22px;
    font-size: 14px;
    font-weight: bold;
    color: #2D2B33;
    letter-spacing: 1px;
    margin-bottom: 20px;

    font-size: 14px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    color: #2D2B33;
    line-height: 19px;
  }

  .flex-container {
    display: flex;
    //justify-content: space-between;
    //width: 504px;
    font-size: 12px;
    color: #2D2B33;

    .flex-column {
      display: flex;
      flex-direction: column;
      width: 94px;
      cursor: pointer;
      position: relative;

      .tag-curr-vip {
        //@include BgImage(19px, 20px, '/_chaotu/pic/detail/icon_curr-vip.png');
        @include Position(1, 5, 0, -7px);
        display: inline-block;
        width: 46px;
        height: 16px;
        background: #FE0000;
        border-radius: 100px 100px 100px 0;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 16px;
        text-align: center;
      }


      @mixin Hover($bgColor: transparent) {
        background: $bgColor;
        border-radius: 8px;
        //overflow: hidden;

        .flex-item {
          //background: $bgColor !important;

          &:nth-child(2n) {
            background: $bgColor;
          }
        }
      }

      &.ON {
        @include Hover(rgba(255, 238, 217, 1))
      }

      &:hover {
        @include Hover(rgba(255, 238, 217, 1))
      }

      &:first-child {
        width: 128px;

        .flex-item {
          padding-left: 18px;
          box-sizing: border-box;
          text-align: left;
        }
      }


      .flex-item {
        height: 34px;
        text-align: center;
        line-height: 34px;

        &:nth-child(2n) {
          background: #FBFBFD;
        }

        .icon-qy-success-circle-fill {
          color: $color-primary;
        }

        .icon-qy-error-circle-fill {
          color: $color-fans;
        }
      }
    }
  }

  .upgrade-btn {
    width: 190px;
    height: 40px;
    background: #6969FF;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    pointer-events: auto;


    @include ElementHover('', rgba(105, 105, 255, 0.5));
  }


}
</style>
